/**
 * // Example usage
 * const rate = 0.05 / 12; // Monthly interest rate (5% annual)
 * const nper = 60;        // Number of payments (5 years)
 * const pv = 30000;       // Loan amount (present value)
 * */
export function PMT(rate, nper, pv, fv = 0, type = 0) {
  if (rate === 0) {
    return -(pv + fv) / nper;
  }

  const pvif = Math.pow(1 + rate, nper);
  let pmt = (rate * (pv * pvif + fv)) / (pvif - 1);

  // Adjust for payments at the beginning of the period
  if (type === 1) {
    pmt /= (1 + rate);
  }

  return -pmt; // Return negative for outflow
}
